<template>
  <div class="app-container">
    <div v-if="loading" class="tw:!text-center tw:!py-12">Loading...</div>
    <div v-else-if="error" class="tw:!text-center tw:!py-12 tw:!text-red-500">{{ error }}</div>
    <template v-else>
      <CheckoutView
        v-if="store.currentView === 'checkout'"
        @back="() => {}"
        @success="handleSuccess"
      />
      <ProfileView
        v-else-if="store.currentView === 'profile'"
        @back="() => {}"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useStore } from '~/composables/widgetMode'
import CheckoutView from '~/components/CheckoutView.vue'
import ProfileView from '~/components/ProfileView.vue'

const store = useStore()
const loading = ref(true)
const error = ref('')

onMounted(async () => {
  const params = new URLSearchParams(window.location.search)
  const invoiceId = params.get('invoiceId')

  console.log('[CheckoutApp] invoiceId from URL:', invoiceId)
  console.log('[CheckoutApp] full URL:', window.location.href)

  if (!invoiceId) {
    error.value = 'Invoice not found'
    loading.value = false
    console.warn('[CheckoutApp] No invoiceId in URL')
    return
  }

  try {
    console.log('[CheckoutApp] Fetching invoice...')
    const ok = await store.fetchDataInvoice(invoiceId)
    console.log('[CheckoutApp] fetchDataInvoice result:', ok)
    console.log('[CheckoutApp] store.currentInvoice:', store.currentInvoice)

    if (!ok) {
      error.value = 'Invoice is invalid or already paid'
    } else {
      store.currentView = 'checkout'
    }
  } catch (e) {
    console.error('[CheckoutApp] Error:', e)
    error.value = 'Failed to load invoice'
  } finally {
    loading.value = false
  }
})

const handleSuccess = (orderNo: string) => {
  store.ProfileStep(orderNo)
}
</script>